import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsQuizUpdate } from '@/learnpaths/components/LearnpathsAddElementsQuizUpdate/LearnpathsAddElementsQuizUpdate'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(quiz)/update/quiz/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsQuizUpdate {...params} />
}
